<template>
  <router-view></router-view>
</template>
<script>
import postscribe from 'postscribe';

export default {
  
   created(){
    postscribe('#main-head', '<link rel="stylesheet" href="/bootstrap.min.css"/>');
    postscribe('#main-head', '<link rel="stylesheet" href="/assets/css/plugins.css" rel="stylesheet" type="text/css" />');
    postscribe('#main-head', '<link rel="stylesheet" href="/assets/css/users/login-1.css" rel="stylesheet" type="text/css" />');

    postscribe('#main-body', '<script src="/assets/js/libs/jquery-3.1.1.min.js"><\/script>');
    postscribe('#main-body', '<script>$("#main-body").removeClass("default-sidebar").addClass("login");<\/script>');
    postscribe('#main-body', '<script src="/assets/js/loader.js"><\/script>');
    postscribe('#main-body', '<script src="/bootstrap/js/popper.min.js"><\/script>');
    postscribe('#main-body', '<script src="/bootstrap/js/bootstrap.min.js"><\/script>');

  },
};
</script>
<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.1s;
}

.fade-enter,
  .fade-leave-to
  /* .fade-leave-active in <2.1.8 */

 {
  opacity: 0;
}
</style>
